import { useEffect, useState } from "react";
import { PhoneCall, ChevronDown, Bot, User } from "lucide-react";
import { api } from "@/lib/api";

const intentColor = {
  booking: "bg-emerald-100 text-emerald-700",
  enquiry: "bg-blue-100 text-blue-700",
  order: "bg-amber-100 text-amber-700",
  complaint: "bg-red-100 text-red-700",
  message: "bg-purple-100 text-purple-700",
  other: "bg-slate-100 text-slate-600",
};

export default function CallLogs() {
  const [calls, setCalls] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    api.get("/calls").then((r) => setCalls(r.data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="calls-view">
      <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight">Call Logs</h1>
      <p className="text-slate-500 mt-1">Every conversation, summarised — with the full transcript on hand.</p>

      <div className="mt-6 space-y-3">
        {calls.length === 0 && (
          <div className="rounded-xl border border-slate-200 bg-white p-10 text-center text-slate-400 text-sm">
            No calls yet. Try the live demo on the home page, then save it as a call.
          </div>
        )}
        {calls.map((c) => (
          <div key={c.id} data-testid="call-row" className="rounded-xl border border-slate-200 bg-white overflow-hidden">
            <button
              onClick={() => setOpen(open === c.id ? null : c.id)}
              className="w-full flex items-start gap-4 px-5 py-4 text-left hover:bg-slate-50 transition-colors"
            >
              <div className="h-9 w-9 rounded-full bg-slate-100 flex items-center justify-center text-slate-500 shrink-0"><PhoneCall className="h-4 w-4" /></div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <p className="font-semibold text-sm text-slate-900">{c.caller_name}</p>
                  <span className={`rounded-full px-2 py-0.5 text-xs font-semibold capitalize ${intentColor[c.intent] || intentColor.other}`}>{c.intent}</span>
                  <span className="text-xs text-slate-400">· {c.turns} turns · {c.channel}</span>
                </div>
                <p className="text-sm text-slate-600 mt-1">{c.summary}</p>
              </div>
              <ChevronDown className={`h-4 w-4 text-slate-400 shrink-0 transition-transform ${open === c.id ? "rotate-180" : ""}`} />
            </button>
            {open === c.id && (
              <div className="border-t border-slate-100 bg-slate-50 px-5 py-4 space-y-3">
                {c.transcript.map((m, i) => (
                  <div key={`${c.id}-${i}`} className={`flex gap-2 ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                    {m.role === "assistant" && <div className="h-6 w-6 rounded-full bg-blue-600 flex items-center justify-center text-white shrink-0"><Bot className="h-3.5 w-3.5" /></div>}
                    <div className={`max-w-[75%] rounded-xl px-3 py-2 text-sm ${m.role === "user" ? "bg-slate-900 text-white" : "bg-white border border-slate-200 text-slate-700"}`}>{m.text}</div>
                    {m.role === "user" && <div className="h-6 w-6 rounded-full bg-slate-200 flex items-center justify-center text-slate-600 shrink-0"><User className="h-3.5 w-3.5" /></div>}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
